import React from 'react'
import FeedbacksView from '../../../../components/performance/FeedbacksView'

export default function ReceivedFeedbacksPage() {
  return (
    <FeedbacksView />
  )
}
